export const tools = [
  "FormatBlock",
  ["Bold", "Italic","Underline"],
  ["Link", "Unlink"],
  ["OrderedList", "UnorderedList"],
  ["Indent", "Outdent"],
  ["Undo", "Redo"],
  ["CleanFormatting"],
];

export const basicTools = [
  ["Bold", "Italic","Underline"],
  ["OrderedList", "UnorderedList"],
  ["Undo", "Redo"],
  ["CleanFormatting"],
];

export default tools;
